import { adminApi } from './api';

/* ==========================================
  인증 (Auth)
========================================== */

/* 어드민 로그인 (1단계: OTP 발송, 202 + preAuthToken) */
export const fetchLogin = async (body) => {
  const response = await adminApi.post(`/api/login`, body);
  return response;
};

/* OTP 검증 (2단계: JWT는 응답 헤더 Authorization) */
export const fetchVerifyOtp = async (body) => {
  const response = await adminApi.post(`/api/auth/verify-otp`, body);
  return response;
};

/* 어드민 로그아웃 */
export const fetchLogout = async () => {
  const response = await adminApi.post(`/api/logout`, {});
  return response;
};

/* 내 현재 로그인 정보 조회 */
export const fetchMyInfo = async () => {
  const response = await adminApi.get(`/api/admin/users/me`);
  return response.data.data;
};